import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/hooks/useAuth";
import {
  NOTIFICATION_CAP,
  loadAdminNotificationCountsFn,
  loadDoctorNotificationCountsFn,
} from "./useNotificationCount.functions";

export function useNotificationCount() {
  const { user, primaryRole } = useAuth();

  const { data } = useQuery({
    queryKey: ["notification-count", user?.id ?? null, primaryRole ?? null],
    enabled: !!user && !!primaryRole,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
    staleTime: 30_000,
    queryFn: async () => {
      if (primaryRole === "admin") {
        const { claims: c, requests: r, alerts: a } = await loadAdminNotificationCountsFn();
        return { claims: c, requests: r, alerts: a, total: c + r + a, cap: NOTIFICATION_CAP };
      }
      if (primaryRole === "doctor" && user) {
        const { claims: c, requests: r } = await loadDoctorNotificationCountsFn();
        return { claims: c, requests: r, alerts: 0, total: c + r, cap: NOTIFICATION_CAP };
      }
      return { claims: 0, requests: 0, alerts: 0, total: 0, cap: NOTIFICATION_CAP };
    },
  });

  return data ?? { claims: 0, requests: 0, alerts: 0, total: 0, cap: NOTIFICATION_CAP };
}
